




import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import ButtonMixin from "@/mixins/ButtonMixin";
import i18n from "@/i18n";
import ActionButton from "@/components/Button/ActionButton.vue";
@Component({
  components: { ActionButton },
})
export default class SettingsButton extends mixins(ButtonMixin) {
  public name = "SettingsButton";

  @Prop({ default: () => i18n.t("general.button_settings_branch") })
  public tooltipLabel!: string;
}
